module.exports = __webpack_public_path__ + "img/phone10.e4beaa97.png";